export function generateRandomString(length) {
    let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
}

export function distanceArray(startValue, endValue) {
    let result = [];
    for (let i = startValue; i <= endValue; i++) result.push(i);
    return result;
}

export const getPercentageValue = (total, percent) => {
    if (total && percent) {
        let amount = total * (Number(percent) / 100);
        return (amount);
    } else {
        return 0;
    }
}